import * as React from "react"

import { Flex, Stack, StackDivider, Box, Button, Badge } from "@chakra-ui/react"

import { AlertEntity, AlertZoneEntity } from "../lib/types/alert"

import { AlertItem } from "./AlertItem"
import { useOrgs } from "./providers/OrgProvider"

interface ZoneAlertsItemProps {
  zone: AlertZoneEntity
  index: number
  alerts: AlertEntity[]
  refetchAlerts: () => Promise<any>
  onSelect: () => void
}

export const ZoneAlertsItem: React.FC<ZoneAlertsItemProps> = (props) => {
  const { currentOrgs } = useOrgs()
  const [muteItem, setMuteItem] = React.useState(false)
  const handleShowItem = () => setMuteItem(true)
  return (
    <Box
      bg={props.index % 2 === 0 ? "gray.50" : "white"}
      p={3}
      style={{ opacity: muteItem ? 0.2 : 1 }}
      borderRadius="lg"
      my={2}
    >
      <Flex mb={1}>
        <Flex position="relative" direction="column" align="flex-start" w="100%">
          <Badge variant="outline" position="absolute" right={1} top={1}>
            Zone
          </Badge>
          <Button
            outline="none"
            variant="link"
            onClick={props.onSelect}
            fontSize="1.2rem"
            w="100%"
            justifyContent="flex-start"
            fontWeight="bold"
            color="gray.700"
            isDisabled={!!!props.zone.location}
          >
            {props.zone.zone_name || "N/A"}
          </Button>
        </Flex>
      </Flex>
      <Stack spacing={1} divider={<StackDivider />}>
        {props.alerts.map((alert) => {
          const alertOrg = currentOrgs.find(({ url }) => url === alert.organization)!
          return (
            <AlertItem
              key={alert.uuid}
              alert={alert}
              refetchAlerts={props.refetchAlerts}
              organization={alertOrg}
              onMuteAlert={handleShowItem}
            />
          )
        })}
      </Stack>
    </Box>
  )
}
